module.exports = "<div class='column' data-dojo-attach-point=\"containerNode\"></div>"